import { Button } from "../../../ui/button";

export interface EditorButtonProps {
    icon: React.ReactNode;
    onClick: () => void;
    isActive?: boolean;
    title: string;
    divider?: boolean;
}

const EditorButton = ({
    icon,
    onClick,
    isActive = false,
    title,
    divider = false
}: EditorButtonProps) => {
    return (
        <>
            <Button
                type="button"
                variant="ghost"
                size="icon"
                onClick={onClick}
                className={`text-white ${isActive ? 'bg-zinc-700' : ''}`}
                title={title}
            >
                {icon}
            </Button>
            {divider && <div className="w-px h-6 bg-zinc-700 mx-1" />}
        </>
    );
};


export default EditorButton;